import React, { useEffect, useState, useRef } from 'react'

import { ScrollView, View, StyleSheet, Keyboard, TouchableOpacity, Text, Platform } from 'react-native'
import delay from 'delay'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  Space,
  TextInputExtended,
  Button,
  Label,
  KeyboardAvoidingView,
  DateTextInputs,
  Anchor,
  AnimatedEllipsis
} from '@sart/components'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import client, { orderHelper, useData } from '@sart/client'
import { useContent } from '@sart/content'

import AppConfig from '../Configuration'
import account from './account.json'
import * as theme from '../Sign/signTheme'
import { HelpIcon } from '@sart/icons'
import { testID } from '@sart/utilities'

export default function ServiceSettings(props) {
  const { navigation } = props
  const [portInProduct, setPortInProduct] = useState(undefined)
  const [regions, setRegions] = useState([])
  const [helpPoint, setHelpPoint] = useState(false)
  const [orderError, setOrderError] = useState(undefined)

  const content = useContent()

  var formik = useFormik({
    initialValues: {
      number: '',
      code: '',
      day: '',
      month: '',
      year: '',
    },
    validationSchema: Yup.object().shape({
      number: Yup.string().trim().required(content.forms.required).matches(/^(07[0-9]{9})$/, content.switch_number.numberNotValid),
      code: Yup.string().trim().required(content.forms.required).matches(/^[A-Z]{3}[0-9]{6}$|^[0-9]{6}[A-Z]{3}$/, content.switch_number.invalidPAC),
    }),
    onSubmit: handleSubmit,
  })

  function setToTomorrow() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    formik.setFieldValue('day', String(tomorrow.getDate()).padStart(2, '0'));
    formik.setFieldValue('month', String(tomorrow.getMonth() + 1).padStart(2, '0'));
    formik.setFieldValue('year', String(tomorrow.getFullYear()));
  }

  async function handleSubmit(values, form) {
    Keyboard.dismiss()

    const inputDate = new Date(values.year, values.month - 1, values.day)
    const today = new Date()
    const diffTime = inputDate.getTime() - today.setHours(0, 0, 0, 0)
    const diffDays = diffTime / (1000 * 60 * 60 * 24) //This is a Copilot special, checking date is within 30 days

    if (isNaN(inputDate.getTime())) {
      form.setFieldError('day', content.port.invalidDate)
      throw new Error(content.port.invalidDate)
    }

    if (diffDays < 1 || diffDays > 30) {
      form.setFieldError('day', content.port.dateOutOfRange)
      throw new Error(content.port.dateOutOfRange)
    }

    form.setSubmitting(true)
    setOrderError(undefined)
    try {
      //Not Needed as handled by Yup validation
      //check regex for mobile number before submission
      // const test = new RegExp(AppConfig.numberRegex, 'g')
      // if (!test.test(values.number)) {
      //   formik.setFieldError('number', content.switch_number.invalidNumber)
      //   throw new Error(content.switch_number.invalidNumber)
      // }


      const portInProducts = await client.callApi('catalog', 'getModifyServiceDetailsProducts', [client.cache.catalogId])

      const portInProduct = portInProducts.find(product => product.productLegacyId === AppConfig.portInProduct)
      console.log('Port in product', portInProduct)

      if (!portInProduct) {
        throw new Error(content.switch_number.portInProduct)
      }

      const extendedData = {
        authCode: values.code,
        msisdn: values.number,
        requestedDate: `${values.year}-${values.month}-${values.day}`
      }

      //sumbit order
      const order = await client.checkoutServiceProduct(portInProduct, extendedData)

      console.log('Order is:', JSON.stringify(order, null, 2))
      form.setSubmitting(false)

      if (order && order.status === 'successful') {

        const params = {
          confirmation: {
            title: content.port.confirmationTitle,
            description: content.port.confirmationInstruction
          }
        }
        navigation.navigate('Confirmation', params)

      } else {
        setOrderError(content.port.orderFailed)
      }

    } catch (error) {
      console.log(JSON.stringify(error, null, 2))
      // const message = prettyErrorMessage(error)

      // form.setFieldError('gender', message)
      form.setSubmitting(false)
    }
  }

  const scrollViewRef = useRef();


  var namesRef, forenameRef, surnameRef, curpRef, postcodeRef;

  return (
    <KeyboardAvoidingView style={styles.container}>
      <ScrollView contentContainerStyle={{ height: '100%', width: '100%', alignItems: 'center' }} keyboardShouldPersistTaps={'always'}
      // ref={scrollViewRef}
      >
        <View style={styles.widthRestrictions}>
          <TextInputExtended
            label={content.port.oldNumberLabelTwo}
            value={formik.values.number}
            placeholder={content.port.oldNumberPlaceholder}
            keyboardType="phone-pad"
            onChangeText={formik.handleChange('number')}
            onBlur={formik.handleBlur('number')}
            error={formik.touched.number && formik.errors.number}
            {...theme.textInput}
            // fontSize={12}
            returnKeyType="next"
            onSubmitEditing={() => postcodeRef.focus()}
            selectionColor={colors.common}
            maxLength={11}
            {...testID('switchNumberLikeToKeep')}
          />

          <Space height={24} />
          <View>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ color: colors.brightOrange, ...typography.demi }}>{content.port.pacCodeLabel}</Text>
              <Space width={4} />
              <TouchableOpacity style={{ ...styles.helpIcon, ...typography.demi }} onPress={() => setHelpPoint(!helpPoint)}>
                <HelpIcon color={colors.brightOrange} />
                <Space height={8} />
              </TouchableOpacity>
            </View>
            {helpPoint &&
              <>
                <View style={styles.helpPointContainer}>
                  <Text style={styles.helpPointText}>
                    {content.port.helpPoint}
                  </Text>
                </View>
                <Space height={12} />
              </>
            }
          </View>
          <TextInputExtended
            value={formik.values.code}
            placeholder={content.port.pacCodePlaceholder}
            // keyboardType="phone-pad"
            onChangeText={formik.handleChange('code')}
            onBlur={formik.handleBlur('code')}
            error={formik.touched.code && formik.errors.code}
            footer={content.port.pacCodeFooter}
            maxLength={9}
            {...theme.textInput}
            // ref={ref => {
            //   postcodeRef = ref;
            // }}
            returnKeyType="next"
            onSubmitEditing={() => namesRef.focus()}
            selectionColor={colors.common}
            {...testID('switchNumberNIP')}
          />

          <Space height={24} />

          <DateTextInputs
            label={content.port.portDateLabel}
            day={formik.values.day}
            dayPlaceholder={content.register_details.day}
            onDayChange={formik.handleChange('day')}
            onDayBlur={formik.handleBlur('day')}
            month={formik.values.month}
            monthPlaceholder={content.register_details.month}
            onMonthChange={formik.handleChange('month')}
            onMonthBlur={formik.handleBlur('month')}
            year={formik.values.year}
            yearPlaceholder={content.register_details.year}
            onYearChange={formik.handleChange('year')}
            onYearBlur={formik.handleBlur('year')}
            error={
              (formik.touched.year && formik.errors.year) ||
              (formik.touched.month && formik.errors.month) ||
              (formik.touched.day && formik.errors.day)
            }
            dayStyle={{ maxWidth: 100 }}
            {...theme.dateInput}
          // ref={ref => {
          //   this.dateRef = ref;
          // }}
          />

          <Space height={12} />

          <Anchor
            title={content.port.setToTomorrow}
            onPress={setToTomorrow}
            style={styles.link}
            {...testID('forgottenPasswordAnchor')}
          />

          <Space height={48} />

          {orderError &&
            <Text style={styles.errorText}>
              {orderError}
            </Text>
          }

          <Button
            title={
              formik.isSubmitting
                ? <AnimatedEllipsis style={{ fontSize: 24, color: colors.clear, ...typography.extrabold }} />
                : content.common.submit
            }
            disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
            onPress={formik.handleSubmit}
            style={styles.enabled}
            disabledStyle={styles.disabled}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
            {...testID('switchNumberSubmit')}
          />

          <Space height={24} />
        </View>

      </ScrollView>
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  selectStyle: {
    ...typography.demi
  },
  link: {
    color: colors.brightOrange,
    fontSize: 16,
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 1
  },
  inputStyle: {
    height: 300
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  label: {
    color: colors.brightOrange,
    ...typography.lightbold,
    fontSize: 16
  },
  helpIcon: {
    justifyContent: 'center'
  },
  helpPointContainer: {
  },
  helpPointText: {
    ...typography.medium,
    color: colors.brightOrange,
    fontSize: 14
  },
  noId: {
    ...typography.demi,
  },
  labelStyles: {
    color: colors.brightOrange,
    ...typography.demi
  },
  enabled: {
    backgroundColor: colors.brightOrange
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    borderColor: colors.brightOrange + 60,
    borderWidth: 1
  },
  errorText: {
    color: 'red',
    marginTop: 4,
    marginBottom: 16,
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi
  })
};